<template>
  <v-btn flat class="pa-2" :to="menuItem.path" :disabled="checkExpiry">
    <v-img
      :src="require('../../assets/images/icons/' + menuItem.icon)"
      contain
      width="50"
      height="50"
    ></v-img>
    <span class="py-2">{{ menuItem.label | translate }}</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    //menu item
    menuItem: {
      type: Object,
      defualt: {}
    },
    expiryFlag: {
      type: Number,
      default: 0
    }
  },
  computed: {
    checkExpiry() {
      if (
        this.expiryFlag === 0 &&
        this.menuItem.path !== "/system" &&
        this.menuItem.path !== "/system/settings" &&
        this.menuItem.path !== "/system/screen" &&
        this.menuItem.path !== "/register"
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
